"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var withChannel_1 = require("./withChannel");

var helpers = withChannel_1.createChannel('responsive', 'auto');
var Broadcast = helpers.Broadcast;
exports.Broadcast = Broadcast;
var withChannel = helpers.withChannel;
exports.withChannel = withChannel;

function mapResponsiveToProps(responsive) {
  return {
    responsive: responsive
  };
}

exports.mapResponsiveToProps = mapResponsiveToProps;

exports.Responsive = function (_a) {
  var mode = _a.mode,
      children = _a.children;
  return React.createElement(Broadcast, {
    channelValue: mode
  }, children);
};

exports.withResponsive = withChannel(mapResponsiveToProps);